import { useCallback } from 'react'
import { Customer, CustomersGetManyRequest, Page } from '../../../types'
import { HttpClientConfig, useHttpClientConfig } from '../../useHttpClientConfig'
import { makeGetCustomers } from './customers'
import { useServiceCountryUrl } from '../useServiceCountryUrl'

interface CustomerService {
  getCustomers: (request: CustomersGetManyRequest) => Promise<Page<Customer>>
  isReady: boolean
}

const useCustomersService = (): CustomerService => {
  const { config } = useHttpClientConfig()
  const { url } = useServiceCountryUrl('customer')
  const baseUrl = url.href

  const getCustomers = useCallback(makeGetCustomers(baseUrl, config as HttpClientConfig), [config])

  return {
    getCustomers,
    isReady: Boolean(config),
  }
}

export { useCustomersService }
